import React from "react";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import ReactDOM from "react-dom";
import useAuth from "../hooks/useAuth";
import Footer from "./common/Footer";
import {
  Link,
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
function EditOrganMenu(props) {
  const { glbId } = useParams();
  console.log("ID", glbId)
  const { user } = useAuth();
  const [dragIndex, setDragIndex] = useState(null);
  const [materialsUI, setMaterialsUI] = useState([]);
  const [modelData, setModelData] = useState([]);
  const [updateSuccessMessage, setUpdateSuccessMessage] = useState([]);

  useEffect(() => {
    getModelDetail();
  }, []);

  const handleDragStart = (e, index) => {
    setDragIndex(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // REQUIRED
  };

  const handleDrop = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) return;

    const updated = [...materialsUI];
    const [movedItem] = updated.splice(dragIndex, 1);
    updated.splice(dropIndex, 0, movedItem);

    setMaterialsUI(updated);
    setDragIndex(null);
  };
  const updateDisplayName = (i, value) => {
    setMaterialsUI((prev) =>
      prev.map((item, idx) =>
        idx === i ? { ...item, displayName: value } : item
      )
    );
  };

  async function getModelDetail() {
    /* 4️⃣ Prepare payload for DB */
    let payloadGlb = {
     _id: glbId,
    };
    console.log("payloadGlb", payloadGlb);
    /* 5️⃣ Get model Detail */
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/update-glb-model-material`,
      payloadGlb
    );

    setModelData(response.data);
    setMaterialsUI(response.data.materials);

  }

  const handleSubmit = async () => {
    const materialConfig = materialsUI.map((m, order) => ({
      originalName: m.originalName,
      displayName: m.displayName,
      order,
    }));

    const payload = {
      _id: glbId,
      materials: materialConfig.length ? materialConfig : undefined,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/update-glb-model-material`,
      payload
    );

    setUpdateSuccessMessage("Updated Successfully");

  };
  return (
    <div className="bg-green5 page-wrapper w-100 min-vh-100 d-flex flex-column h-100">
      <main className="main-section mx-4 rounded-top-3 bg-white userList">
        <span className="fs-4 pt-4 pb-2 fw-bold lh-sm d-flex justify-content-center">
          Materials
        </span>
        <span className="fs-4 pt-4 pb-2 fw-bold lh-sm d-flex justify-content-center">
          {modelData.level1}/{modelData.level2}/{modelData.level3}/{modelData.level4}
        </span>
        {updateSuccessMessage && (
          <div className="text-success text-center mt-2">{updateSuccessMessage}</div>
        )}
        <div className="d-flex justify-content-center mt-4 mb-1">
          <div className="border rounded p-2" style={{ maxHeight: "900px", overflowY: "auto" }}>
            {materialsUI.map((item, i) => (
              <div
                key={item.originalName + i}
                draggable
                onDragStart={(e) => handleDragStart(e, i)}
                onDragOver={handleDragOver}
                onDrop={() => handleDrop(i)}
                className="d-flex align-items-center gap-4 mb-2 p-2 border rounded bg-white"
                style={{ cursor: "grab" }}
              >
                <span className="text-muted">☰</span>
                <span className="badge bg-secondary">{i + 1}</span>

                <span className="text-muted small" style={{ minWidth: "200px" }}>
                  {item.originalName}
                </span>

                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={item.displayName}
                  onChange={(e) => updateDisplayName(i, e.target.value)}
                />
              </div>
            ))}
            <button
              type="button"
              className="btn btn-primary w-100 mt-3"
              onClick={handleSubmit}
            >
              Save Material
            </button>
          </div>


        </div>
      </main>
    </div>
  );
}
export default EditOrganMenu;
